<template>
  <div v-if="showContentDeliverer" class="container justify-content-center">
    <div class="sticky">
      <h1 class="text-center">БАНКОВСКИЕ КАРТЫ</h1>
      <a :href="yoomoneyCardAuthUrl()">
        <button class="btn btn-primary w-100 text-center berry">
          ДОБАВИТЬ КАРТУ
        </button>
      </a>
    </div>

    <div class="main-content">
      <div
        v-for="card in userCards"
        :key="card._id"
        class="container pb-2 pt-1"
      >
        <div class="card lh-1">
          <div class="card-body">
            <div class="row row-cols-2">
              <div class="col text-muted">Тип карты</div>
              <div class="col text-muted">Номер карты</div>
              <div class="col">
                <span class="fs-3">{{ card.type }}</span>
              </div>
              <div class="col">
                <span class="fs-3">{{ card.mask }}</span>
              </div>
            </div>
            <div class="row row-cols-1 pt-3">
              <div v-if="card.default" class="col">
                <button
                  type="button"
                  class="btn btn-info w-100 fs-4"
                  disabled
                >
                  Используется по умолчанию
                </button>
              </div>
              <div v-if="!card.default" class="col">
                <button
                  type="button"
                  class="btn btn-outline-info w-100 fs-4"
                  @click="setCardDefault(card._id)"
                >
                  Назначить по умолчанию
                </button>
              </div>
            </div>

            <div class="row row-cols-1 pt-3">
              <button
                type="button"
                class="btn btn-danger"
                data-bs-toggle="modal"
                :data-bs-target="`#remove-card-confirm-${card.id}`"
              >
                Удалить
              </button>
              <div
                class="modal fade"
                :id="`remove-card-confirm-${card.id}`"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-body">
                      Удалить карту {{ card.type }} {{ card.mask }}?
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="removeCard(card._id)"
                        data-bs-dismiss="modal"
                      >
                        Да
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Нет
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
//import * as bootstrap from 'bootstrap'
//import { Modal } from 'bootstrap'
import useCardsMixin from "@/components/cardsMixin.js";
import useCommonMixin from "@/components/commonMixin.js";

export default {
  name: "Cards",
  components: {},

  setup(props) {
    useCommonMixin();
    const { showContentDeliverer } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    useCardsMixin();
    const { userCards, yoomoneyCardAuthUrl, removeCard } = useCardsMixin();
    
    const setCardDefault = (cardId) => {
      store.dispatch('SETcardDefault', cardId)
    }

    return {
      userCards,
      yoomoneyCardAuthUrl,
      removeCard,
      showContentDeliverer,
      setCardDefault,
    };
  },
};
</script>

<style scoped>
</style>

